const constant = {
  keepLimit: 1800000,
  notifyShowTime: {
    normal: 5000,
    short: 3000,
    long: 10000
  },
  html: {
    loading: './static/html/loading.html', // 読み込み中HTML
    error: './static/html/error.html?msg=' // エラー表示HTML
  },
  userAuthority: {
    system_management: 1,
    application_including: 2,
    application_not_included: 3,
    browsing_including: 4
  },
  isShopMaster: {
    sub: 0,
    boss: 1
  },
  moralState: {
    yet: null,
    stated: 1,
    end: 2
  },
  officerUserIds: [19761, 16002],
  character1Folder: [
    '通常使用',
    '文字バージョン',
    'animal',
    // 'sports',
    // 'タイラニャン',
    'ワンダー系',
    'ワンダーエージェント',
    'ワンダーエージェント_イラスト'
    // 'クリスマス',
    // '特日'
  ],
  character1Image: {
    '通常使用': [
      '16areaA_4',
      '16areaA_5',
      '16areaA_6',
      '15areaA_3',
      '15areaA_5',
      '15areaA_6',
      '15areaA_7',
      '14areaA_1',
      '14areaA_4',
      '14areaA_5',
      '14areaA_6',
      '14areaA_7',
      '14areaA_8',
      '13areaA_1',
      '13areaA_2',
      '13areaA_4',
      '13areaA_5',
      '13areaA_6',
      '13areaA_7',
      '12areaA_06',
      '12areaA_07',
      '12areaA_08',
      '12areaA_15',
      '11areaA_03',
      '11areaA_04',
      '11areaA_05',
      '11areaA_07',
      '11areaA_08',
      '11areaA_09',
      '11areaA_10',
      '11areaA_11',
      '11areaA_12',
      '10areaA_02',
      '10areaA_06',
      '9areaA_03',
      '9areaA_04',
      '9areaA_06',
      '9areaA_08',
      '9areaA_11',
      '8areaA_03',
      '8areaA_04',
      '8areaA_05',
      '8areaA_06',
      '8areaA_09',
      '8areaA_10',
      '8areaA_11',
      '8areaA_12',
      '7areaA_01',
      '7areaA_02',
      '7areaA_06',
      '7areaA_12',
      '7areaA_13',
      '6areaA_1',
      '6areaA_5',
      '6areaA_6',
      '6areaA_9',
      '5areaA_8',
      '5areaA_9',
      '5areaA_12',
      '4areaA_5',
      '4areaA_15',
      '4areaA_16',
      '3areaA_2',
      '3areaA_5',
      // '3areaA_10',
      '3areaA_12',
      // '3areaA_19',
      '2areaA_33',
      '2areaA_42',
      '2areaA_55',
      'areaA_1',
      'areaA_2',
      'areaA_3',
      'areaA_4',
      'areaA_5',
      'areaA_6',
      'sp_3',
      '5areaA_7',
      '4areaA_9',
      '4areaA_17',
      '6areaA_4'
    ],
    '文字バージョン': [
      '12areaA_01',
      '12areaA_03',
      '12areaA_13',
      '11areaA_06',
      '8areaA_08',
      '8areaA_13',
      '8areaA_14',
      '7areaA_05',
      '7areaA_14',
      '2areaA_12',
      'areaA_7',
      'areaA_8',
      'areaA_9',
      'areaA_10',
      'areaA-29',
      'areaA-30',
      'areaA-31',
      'areaA-32',
      'areaA-33',
      'areaA-34'
    ],
    'animal': [
      '16areaA_1',
      '16areaA_3',
      '15areaA_1',
      '15areaA_4',
      '14areaA_2',
      '13areaA_3',
      '12areaA_04',
      '12areaA_05',
      '12areaA_09',
      '12areaA_10',
      '12areaA_12',
      '12areaA_14',
      '10areaA_03',
      '10areaA_04',
      '10areaA_07',
      '10areaA_09',
      '10areaA_10',
      '9areaA_02',
      '9areaA_05',
      '9areaA_07',
      '9areaA_10',
      '7areaA_03',
      '7areaA_04',
      '5areaA_1',
      '5areaA_2',
      '5areaA_3',
      '5areaA_6',
      '5areaA_10',
      '5areaA_11',
      '5areaA_13',
      '4areaA_2',
      '4areaA_6',
      '4areaA_10',
      '3areaA_7',
      '3areaA_8',
      '2areaA_2',
      '2areaA_10',
      '2areaA_39',
      '2areaA_57',
      '2areaA_59',
      'an_1',
      'an_2'
      // 'an_3',
      // 'an_4',
      // 'an_5'
    ],
    // 'sports': [
    // ],
    // 'タイラニャン': [
    // ],
    'ワンダー系': [
      '11areaA_01',
      '11areaA_02',
      '9areaA_01',
      '9areaA_09',
      'areaA-35',
      'tn_1',
      'tn_2',
      'tn_3',
      '3areaA_1',
      '3areaA_3',
      '3areaA_13',
      '3areaA_20',
      '6areaA_3',
      '6areaA_10'
    ],
    'ワンダーエージェント': [
      '5areaA_4',
      '3areaA_4',
      '3areaA_6',
      '3areaA_11',
      '3areaA_14',
      '2areaA_41',
      'ag_1',
      // 'ag_2',
      // 'ag_3',
      // 'ag_4',
      'ag_5',
      'ag_6',
      // 'ag_6(1)',
      'ag_7',
      'ag_8',
      'ag_10',
      'ag11th',
      'ch1',
      'ch2',
      '3areaA_9',
      '3areaA_16',
      '3areaA_17',
      '3areaA_18'
    ],
    'ワンダーエージェント_イラスト': [
      '16areaA_2',
      '15areaA_2',
      '14areaA_3',
      '12areaA_02',
      '12areaA_11',
      '11areaA_13',
      '11areaA_14',
      '11areaA_15',
      '10areaA_01',
      '10areaA_05',
      '10areaA_08',
      '8areaA_01',
      '8areaA_02',
      '8areaA_07',
      '7areaA_07',
      '7areaA_08',
      '7areaA_09',
      '7areaA_10',
      '7areaA_11',
      '6areaA_2',
      '6areaA_7',
      '6areaA_8',
      '6areaA_11',
      '6areaA_12',
      '5areaA_5',
      '4areaA_1',
      '4areaA_3',
      '4areaA_4',
      '4areaA_7',
      '4areaA_8',
      '4areaA_11',
      '4areaA_12',
      '4areaA_13',
      '4areaA_14',
      // '2areaA_19',
      // '2areaA_20',
      // '2areaA_21',
      // '2areaA_25',
      // '2areaA_27',
      // '2areaA_28',
      '2areaA_63',
      'areaA-1',
      'areaA-2',
      'areaA-3',
      'areaA-4',
      'areaA-5',
      'areaA-6',
      'areaA-7',
      'areaA-8',
      'areaA-9',
      'areaA-10',
      'areaA-11',
      'areaA-12',
      // 'areaA-13',
      // 'areaA-14',
      'areaA-15',
      'areaA-16',
      // 'areaA-17',
      // 'areaA-18',
      // 'areaA-19',
      'areaA-20',
      // 'areaA-21',
      'areaA-22',
      'areaA-23',
      // 'areaA-24',
      'areaA-25',
      // 'areaA-26',
      'areaA-27',
      'areaA-28',
      'ag_9'
    ]
    // 'クリスマス': [
    // ],
    // '特日': [
    // ]
  }, // ESmyカード：キャラクター１画像構成 画像名を追加する
  character2Image: [
    '16areaB_1',
    '16areaB_2',
    '16areaB_3',
    '16areaB_4',
    '16areaB_5',
    '16areaB_6',
    '15areaB_1',
    '15areaB_2',
    '15areaB_3',
    '15areaB_4',
    '15areaB_5',
    '15areaB_6',
    '15areaB_7',
    '14areaB_1',
    '14areaB_2',
    '14areaB_3',
    '14areaB_4',
    '14areaB_5',
    '14areaB_6',
    '14areaB_7',
    '14areaB_8',
    '13areaB_1',
    '13areaB_2',
    '13areaB_3',
    '13areaB_4',
    '13areaB_5',
    '13areaB_6',
    '13areaB_7',
    '12areaB_01',
    '12areaB_02',
    '12areaB_03',
    '12areaB_04',
    '12areaB_05',
    '12areaB_06',
    '12areaB_07',
    '12areaB_08',
    '12areaB_09',
    '12areaB_10',
    '12areaB_11',
    '12areaB_12',
    '12areaB_13',
    '12areaB_14',
    '12areaB_15',
    '11areaB_01',
    '11areaB_02',
    '11areaB_03',
    '11areaB_04',
    '11areaB_05',
    '11areaB_06',
    '11areaB_07',
    '11areaB_08',
    '11areaB_09',
    '11areaB_10',
    '11areaB_11',
    '11areaB_12',
    '10areaB_01',
    '10areaB_02',
    '10areaB_03',
    '10areaB_04',
    '10areaB_05',
    '10areaB_06',
    '10areaB_07',
    '10areaB_08',
    '10areaB_09',
    '10areaB_10',
    '9areaB_01',
    '9areaB_02',
    '9areaB_03',
    '9areaB_04',
    '9areaB_05',
    '9areaB_06',
    '9areaB_07',
    '9areaB_08',
    '9areaB_09',
    '8areaB_01',
    '8areaB_02',
    '8areaB_03',
    '8areaB_04',
    '8areaB_05',
    '8areaB_06',
    '8areaB_07',
    '8areaB_08',
    '8areaB_09',
    '8areaB_10',
    '8areaB_11',
    '8areaB_12',
    '7areaB_01',
    '7areaB_02',
    '7areaB_03',
    '7areaB_04',
    '7areaB_05',
    '7areaB_06',
    '7areaB_07',
    '7areaB_08',
    '6areaB_1',
    '6areaB_2',
    '6areaB_3',
    '6areaB_4',
    '6areaB_5',
    '6areaB_6',
    '6areaB_7',
    '6areaB_8',
    // '6areaB_9',
    '6areaB_10',
    '6areaB_11',
    // '5areaB_1',
    // '5areaB_2',
    '5areaB_3',
    '5areaB_4',
    '5areaB_5',
    '5areaB_6',
    '5areaB_7',
    '5areaB_8',
    '5areaB_9',
    '5areaB_10',
    '5areaB_11',
    '5areaB_12',
    '4areaB_1',
    '4areaB_2',
    // '4areaB_3',
    '4areaB_4',
    '4areaB_5',
    '4areaB_6',
    '4areaB_7',
    '4areaB_8',
    '4areaB_9',
    '4areaB_10',
    // '4areaB_11',
    '4areaB_12',
    '4areaB_13',
    '4areaB_14',
    '4areaB_15',
    '4areaB_16',
    '4areaB_17',
    '3areaB_1',
    '3areaB_2',
    '3areaB_3',
    '3areaB_4',
    '3areaB_5',
    '3areaB_6',
    // '3areaB_7',
    // '3areaB_8',
    // '3areaB_9',
    '3areaB_10',
    // '3areaB_11',
    '3areaB_12',
    '3areaB_13',
    '3areaB_14',
    '3areaB_15',
    '3areaB_16',
    '3areaB_17',
    // '3areaB_18',
    '3areaB_19',
    '3areaB_20',
    // '3areaB_21',
    '3areaB_22',
    // 'chB_1',
    '2areaB_6',
    '2areaB_9',
    '2areaB_13',
    '2areaB_16',
    '2areaB_20',
    '2areaB_22',
    '2areaB_24',
    '2areaB_25',
    '2areaB_30',
    '2areaB_31',
    '2areaB_32',
    '2areaB_36',
    // '2areaB_38',
    // '2areaB_39',
    // '2areaB_40',
    'agb_1',
    'agb_2',
    'agb_3',
    'agb_4',
    'agb_5',
    'agb_6',
    'anB_1',
    'anB_2',
    // 'anB_3',
    // 'anB_4',
    // 'anB_5',
    'areaB_1',
    'areaB_2',
    'areaB_3',
    'areaB_4',
    'areaB_5',
    'areaB_6',
    'areaB_7',
    'areaB_8',
    'areaB_9',
    'areaB_10',
    'areaB_01',
    'areaB_02',
    'areaB_03',
    'areaB_04',
    'areaB_05',
    'areaB_06',
    'areaB_07',
    'areaB_08',
    // 'areaB_09',
    // 'areaB_10(1)',
    'spB_3',
    'spB_4',
    'tnB_1',
    'tnB_2',
    'tnB_3'
  ] // ESmyカード：キャラクター2画像構成 画像名を追加する
}

export default constant



// WEBPACK FOOTER //
// ./src/store/constant.js